// Auto-generated skeleton for Priority

export const Priority: Api.Priority = {
  id: 0,
  name: '',
  weight: 0,
  created: null,
  updated: null,
};

